 (function () {
    async function insertSectionCartDrawer() {
      if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return

      var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
      if (!cartDrawerItems) return

      if (cartDrawerItems.classList.contains('is-empty')) return

      var wrapper = document.createElement('div')
      wrapper.classList.add('cart-drawer-items-wrapper')
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
      wrapper.appendChild(cartDrawerItems)

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()
      }
    }
    insertSectionCartDrawer()

  /*  async function insertSectionCartPage() {
      const cartItems = document.querySelector('cart-items')
      if (!cartItems) return

      const existingUpsells = document.querySelector('#MainContent #cart-drawer-upsell')
      if (existingUpsells) {
        existingUpsells.remove()
      }

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      cartItems.querySelector('.page-width').insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()
      }
    }
    insertSectionCartPage() */

    window.onChangeKsUpsellVariantSelector = function( select, event) {
      event.preventDefault()
      const imgSrc = select.options[select.selectedIndex].dataset.variantImg

      if (imgSrc) {
        const img = select.closest('.cart-drawer-upsell-list-item').querySelector('.cart-drawer-upsell-list-item-left img')
        img.src = imgSrc
      }
    }

    // One dropdown per product option (Color / Size) instead of a single flat
    // variant list. Resolves the variant from the selected combination.
    // Delegated on document because the markup is cloned into the drawer and
    // re-rendered on every cart change, which would drop direct listeners.
    function resolveUpsellVariant(item) {
      const dataNode = item.querySelector('.cart-upsell-variants')
      if (!dataNode) return null

      let variants
      try {
        variants = JSON.parse(dataNode.textContent)
      } catch (error) {
        return null
      }

      const chosen = Array.from(item.querySelectorAll('.cart-upsell-option'))
        .sort(function (a, b) {
          return Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
        })
        .map(function (select) {
          return select.value
        })

      return variants.find(function (variant) {
        return variant.options.length === chosen.length
          && variant.options.every(function (value, index) {
            return value === chosen[index]
          })
      }) || null
    }

    function syncUpsellItem(item) {
      const variant = resolveUpsellVariant(item)
      const idInput = item.querySelector('.cart-upsell-variant-id')
      const addButton = item.querySelector('button[name="add"]')
      const priceNode = item.querySelector('.cart-upsell-price')
      const image = item.querySelector('.cart-drawer-upsell-list-item-left img')

      if (!variant || !variant.available) {
        if (idInput) idInput.value = ''
        if (addButton) addButton.disabled = true
        return
      }

      if (idInput) idInput.value = variant.id
      if (addButton) addButton.disabled = false

      if (priceNode) {
        priceNode.innerHTML = variant.compareAtPrice
          ? '<s>' + variant.compareAtPrice + '</s> ' + variant.price
          : variant.price
      }

      if (image && variant.image) image.src = variant.image
    }

    document.addEventListener('change', function (event) {
      const target = event.target
      if (!target || !target.closest) return

      const select = target.closest('.cart-upsell-option')
      if (!select) return

      const item = select.closest('.cart-drawer-upsell-list-item')
      if (!item) return

      syncUpsellItem(item)
    })

    // The upsell markup wraps its form in <product-form>, but product-form.js is
    // only loaded on product pages. Anywhere else the custom element never
    // upgrades, the form posts natively to /cart/add and the browser lands on the
    // cart page instead of adding in place. Handle the submit here so the item is
    // added over AJAX and the drawer re-renders, wherever the upsell shows up.
    function addUpsellToCart(form) {
      const button = form.querySelector('button[name="add"]')
      const drawer = document.querySelector('cart-drawer')

      const body = new FormData(form)
      body.append('sections', 'cart-drawer,cart-icon-bubble')
      body.append('sections_url', window.location.pathname)

      if (button) {
        button.setAttribute('aria-disabled', 'true')
        button.classList.add('loading')
      }

      const restore = function () {
        if (!button) return
        button.removeAttribute('aria-disabled')
        button.classList.remove('loading')
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: body
      })
        .then(function (response) { return response.json() })
        .then(function (state) {
          // Shopify returns a `status` field only on errors (sold out, bad id...)
          if (state.status) throw new Error(state.description || state.message)

          if (drawer && state.sections) {
            drawer.renderContents(state)
          } else {
            window.location = '/cart'
          }
          restore()
        })
        .catch(function () {
          restore()
          window.location = '/cart'
        })
    }

    document.addEventListener('submit', function (event) {
      const form = event.target
      if (!form || !form.matches) return
      if (!form.matches('.cart-drawer-upsell-list-item form')) return

      // On product and collection pages the theme loads product-form.js, whose
      // <product-form> wrapper handles this submit itself (AJAX + drawer render)
      // and calls preventDefault() before the event bubbles up to document.
      // Stepping in as well would add the item twice.
      if (event.defaultPrevented) return

      event.preventDefault()

      // Ignore taps while a previous add is still in flight.
      const button = form.querySelector('button[name="add"]')
      if (button && button.getAttribute('aria-disabled') === 'true') return

      addUpsellToCart(form)
    })

    function listenCartDrawer() {
      const element = document.querySelector('cart-drawer')
      if (!element) return

      let timer

      const observer = new MutationObserver((mutations) => {
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#cart-drawer-upsell-wrapper')
            .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))

            insertSectionCartDrawer()
        }, 250)
      })

      observer.observe(element, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
    listenCartDrawer()

    function listenCartPage() {
      const element = document.querySelector('#MainContent .cart__items')
      if (!element) return

      let timer

      const observer = new MutationObserver((mutations) => {
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#cart-drawer-upsell-wrapper')
            .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))

            insertSectionCartPage()
        }, 250)
      })

      observer.observe(element, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
    listenCartPage()
  })();
